module.exports = __webpack_public_path__ + "img/MatthewJanney-NikaAmashukeli.4953b82c.webp";